import React from 'react';
import { DealershipUserV1 } from '../../services/dealerships/types';
import { Avatar, Icon } from 'lynkco-up-core';

interface UserCardProps extends DealershipUserV1 {
  onClick?: () => void;
  onClickDelete?: (user: DealershipUserV1) => void;
}

const UserCard: React.FC<UserCardProps> = ({ onClick, onClickDelete, ...user }) => {
  if (user === undefined || user.firstName == '' || user.email == '' || user.id == '') {
    return <div />;
  }
  return (
    <div className="">
      <div onClick={onClick} className="flex center items-stretch border border-black rounded-lg p-4 max-w-md bg-white">
        <div className="flex flex-row align-center">
          <Avatar
            size="extraLarge"
            src={user.urlProfilePicture ?? ''}
            alt={user.firstName ?? ''}
            extraClasses="my-auto mr-4"></Avatar>
          <div className="flex flex-col">
            <div className="text-lg text-xl font-bold">{user.firstName}</div>
            <div>{user.email}</div>
            <div>User ID: {user.id}</div>
          </div>
          {onClickDelete && (
            <div className="flex ml-2">
              <div onClick={() => onClickDelete(user ?? {})} className="cursor-pointer m-auto">
                <Icon variant="danger" size="large" name="delete"></Icon>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
  // return (
  //   <div>
  //     <div onClick={onClick} className="flex items-stretch border border-black rounded-lg p-2 max-w-md bg-white">
  //       {/* Text Section */}
  //       <div className="flex flex-col justify-center flex-grow-4">
  //         <p className="text-lg text-xl font-bold">{user.firstName}</p>
  //         <p className="text-lg text-gray-600">{user.email}</p>
  //         <p className="text-lg text-gray-500">User ID: {user.id}</p>
  //       </div>

  //       {/* Profile Picture */}
  //       <div className="flex items-center">
  //         <Avatar size="extraLarge" src={user.urlProfilePicture ?? ''} alt={user.firstName ?? ''}></Avatar>
  //       </div>
  //       {onClickDelete && (
  //         <div onClick={() => handleUserClick(user ?? {})}>
  //           <Icon variant="danger" size="large" name="delete"></Icon>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
};

export default UserCard;
